import { createFileRoute } from '@tanstack/react-router';

import EditRevisionPage from '@/components/products/specific/edit/revisionId/Page';

export const Route = createFileRoute('/products/$id/edit_/$revisionId')({
	component: EditRevisionPage,
});
